import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useLocation } from "react-router-dom"; // Добавьте useLocation
import { getUserData } from "../../../store/account/accountActions";
import BurgerMenuClose from "../images/burger-close.png";
import BurgerMenu from "../images/burger-menu.png";
import founded_en from "./assets/founded-en.png";
import founded_kg from "./assets/founded-kg.png";
import founded_ru from "./assets/founded-ru.png";
import MenuModal from "./MenuModal";
import "./Navbar.scss";
import NavbarCreatePetiton from "./NavbarCreatePetition";
import NavbarDropDown from "./NavbarDropdown";
import NavbarItems from "./NavbarItems";
import NavbarLangSelector from "./NavbarLangSelector";
import NavbarLoginModal from "./NavbarLoginModal";
import NavbarLogos from "./NavbarLogos";
import NavbarVerifyModal from "./NavbarVerifyModal";
import NavbarVoiceButton from "./NavbarVoiceButton";

//PROD: Only for production
import ReactGA from 'react-ga4';
//UAT: Nothing

const FOUNDED = {
  ru: founded_ru,
  ky: founded_kg,
  en: founded_en,
};

const Navbar = () => {
  const [t, i18n] = useTranslation("global");
  const [isShowModal, setIsShowModal] = useState(false);

  const [isVerified, setIsVerified] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isVerifyAccount, setisVerifyAccount] = useState(false);

  const [isOpen, setIsOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobLangOpen, setIsMobLangOpen] = useState(false);
  const [euImage, setEuImage] = useState(FOUNDED.ru);
  const [language, setLanguage] = useState("ru");


  const location = useLocation(); 

  const dispatch = useDispatch();
  const user = useSelector((state) => state.account.userData);
  const userStatus = user?.status || "";

  useEffect(() => {
    //const isLoggedIn = checkUserLogin();
    // setIsLoggedIn(isLoggedIn);
    // PROD:
    ReactGA.initialize('G-EG7GFRXKT5');
    ReactGA.send({ hitType: "pageview", page: location.pathname, title: "Page View: " + location.pathname });
    // UAT: Nothing
    dispatch(getUserData());

  }, [dispatch, location]);


  useEffect(() => {
    setIsLoggedIn(!!user);
    setIsVerified(userStatus === "Верифицирован");
  }, [user, userStatus]);

  // Предотвращаем скролл страницы когда открыто мобильное меню
  useEffect(() => {
    if (isMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // Очищаем стили при размонтировании компонента
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMenuOpen]);


  const handleChangeLanguage = (lang) => {
    i18n.changeLanguage(lang);
    setIsOpen(false);
    setIsMobLangOpen(false);
    setLanguage(lang);
    setEuImage(FOUNDED[lang]);
  };
  return (
    <div className="navbar">
      <div className="navbar__content container">
        <div className="navbar__logo">
          <NavbarLogos euImage={euImage} />
          <div className="navbar__lang">
            <div className="navbar__dropdown">
              <NavbarDropDown
                setIsOpen={setIsOpen}
                isOpen={isOpen}
                language={language}
              />
              {isOpen && (
                <NavbarLangSelector
                  handleChangeLanguage={handleChangeLanguage}
                />
              )}
            </div>
          </div>
        </div>
        <div className="navbar__menu">
          <NavbarItems />
        </div>
        {isShowModal && (
          <NavbarLoginModal setIsShowModal={setIsShowModal} t={t} />
        )}
        <div className="navbar__button">
          <NavbarVoiceButton setIsMenuOpen={setIsMenuOpen} />
          <NavbarCreatePetiton
            isLoggedIn={isLoggedIn}
            isVerified={isVerified}
            setisVerifyAccount={setisVerifyAccount}
            setIsShowModal={setIsShowModal}
          />
          <NavLink to={isLoggedIn ? "/profile" : "/login"}>
            <button>
              {isLoggedIn ? t("navbar.profile") : t("navbar.signIn")}
            </button>
          </NavLink>
        </div>
        {isMenuOpen ? (
          <img
            className="navbar__burgerMenu"
            src={BurgerMenuClose}
            alt="close"
            onClick={() => setIsMenuOpen(false)}
          />
        ) : (
          <img
            className="navbar__burgerMenu"
            src={BurgerMenu}
            alt="menu"
            //onClick={() => setIsMenuOpen(!isMenuOpen)}
            onClick={() => setIsMenuOpen(true)}
          />
        )}
        {isVerifyAccount && (
          <NavbarVerifyModal setisVerifyAccount={setisVerifyAccount} />
        )}
        {isMenuOpen && (
          <>
            <div 
              className={`navbar__overlay ${isMenuOpen ? 'navbar__overlay--visible' : ''}`}
              onClick={() => setIsMenuOpen(false)}
            />
            <MenuModal
              setIsMenuOpen={setIsMenuOpen}
              setisVerifyAccount={setisVerifyAccount}
              setIsShowModal={setIsShowModal}
              isLoggedIn={isLoggedIn}
              isVerified={isVerified}
              isMenuOpen={isMenuOpen}
              isMobLangOpen={isMobLangOpen}
              handleChangeLanguage={handleChangeLanguage}
              setIsMobLangOpen={setIsMobLangOpen}
            />
          </>
        )}
      </div>
    </div>
  );
};

export default Navbar;
